<template>
  <div class="uploadAttachment">
    <div class="title">
      <span>相关凭证</span>
      <!-- <span class="content">选择您要上传的照片</span> -->
    </div>
    <div class="uploadBox">
      <van-uploader
        :after-read="afterRead"
        multiple
        accept="image/*"
        preview-image
        v-model="files"
        preview-full-image
        preview-size="72px"
        :before-read="beforeRead"
        @delete="deleteFile"

      >

        <!-- <van-uploader
        :after-read="afterRead"
        multiple
        accept="image/*"
        preview-image
        v-model="files"
        preview-full-image
        preview-size="72px"
        :before-delete="handleDelete"
        @delete="deleteFile"
        :before-read="beforeRead"
      > -->
        <img src="../../../../assets/refund/icon_UploadPic@2x.png" alt="">

      <!-- <div class="uploadIcon">
        <img style="width:26px;height:26px;" src="../../../../assets/refund/ic_photoPic@2x.png" alt="">
      </div> -->
      </van-uploader>
    </div>
  </div>
</template>

<script>
    import api from '@/service/modules/complaint';
    import util from '@/utils/common';
    export default {
        props: ['fileBizType', 'sourceId', 'localFiles'], // sourceId为退货详情的basicid
        data () {
            return {
                files: [], // 待上传的文件
                uploadFile: [], // 上传成功后的文件,
                temporaryFiles: [],
                uploadFileUrl: []
            };
        },
        watch: {
            localFiles (newVal, oldVal) {
                if (newVal) {
                    this.files = newVal
                }
            }
        },
        created () {
            if (this.localFiles) {
                this.files = this.localFiles
            }
        },
        methods: {
            deleteFile (file) {
                console.log('删除', this.files);
              this.uploadFile = []
                this.uploadFileUrl = []
                if (this.$route.fullPath == '/refund/secondRefund') {
                    localStorage.setItem('fileCache', JSON.stringify(this.files))
                }
                // 重新上传当前最新文件
                // this.temporaryFiles =  this.temporaryFiles.filter(i => i.file.lastModified != file.file.lastModified)
                // console.log('this.temporaryFiles', this.temporaryFiles);
                this.afterRead(this.files, false)
            },
             beforeRead(file) {
                let flag = true
                // 如果file是数组的时候代表本次上传多张
                if (file.length && file.length > 9) {
                    this.$toast({
                        message: '一次最多可以上传9张',
                        duration: 2000
                  });
                  flag = false
                } else {
                    // 如果本次只上传了单张
                    if (this.files.length + 1 > 20) {
                        this.$toast({
                            message: '最多可以上传20张',
                            duration: 2000
                        });
                        flag = false
                    }
                }
                // 如果本次上传了多张，总共超过20张
                if (file.length && (file.length + this.files.length > 20)) {
                   this.$toast({
                        message: '最多可以上传20张',
                        duration: 2000
                  });
                  flag = false
                }
                return flag
                },
            // 删除预览文件
            handleDelete (files) {
                this.$store.commit('refund/delTempFiles', files)
                if (files instanceof Object) {
                    if (files.hasOwnProperty('file')) {
                        // 删除源文件
                        let imgItem;
                        this.temporaryFiles.forEach(element => {
                            if (element.hasOwnProperty(files.file.lastModified)) {
                                imgItem = element[files.file.lastModified];
                            }
                        });

                        if (imgItem) {
                            this.uploadFile = this.uploadFile.filter(item => {
                                return item !== imgItem;
                            });
                        }
                    }
                    this.$emit('fileuploadData', this.uploadFile);
                    // this.$dispatch("fileUploadData", [...this.uploadFile]);
                    return true;
                }
            },
            lastAfterRead() {
                console.log('lastAfterRead1111111111111111111');
                this.afterRead(this.files, false)
            },
            // 文件读取完成
            afterRead (files, showLoading) {
                console.log('读取完成', this.files);
                this.uploadFile = []
                this.uploadFileUrl = []
                const newFiles = this.files
                // 此时可以自行将文件上传至服务
                if (Array.isArray(newFiles)) {
                    newFiles.forEach(item => {
                        let formData = new FormData();
                        formData.append('files', item.file);
                        formData.append('fileBizType', this.fileBizType);
                        if (this.sourceId) {
                            formData.append('sourceId', this.sourceId);
                        }
                        this.handleUploadFile(formData, item, showLoading);
                    });
                } else {
                    let formData = new FormData();
                    formData.append('files', newFiles.file);
                    formData.append('fileBizType', this.fileBizType);
                    if (this.sourceId) {
                        formData.append('sourceId', this.sourceId);
                    }
                    // formData.append("sourceId", '2c288a107bed698d017bed8b2c14000c');
                    // formData.append("files", files.file);
                    this.handleUploadFile(formData, newFiles, showLoading);
                }
            },
            // 上传
            handleUploadFile (data, files, showLoading) {
                let currentFile = files;
                if (showLoading) {
                    this.$Toast.loading({
                        duration: 0,
                        message: '文件上传中...',
                        forbidClick: true
                    });
                }
                let config = {
                    headers: {
                        // 添加请求头
                        'Content-Type': 'multipart/form-data',
                        mobile: 13000000002,
                        // 'x-token': 'ZGJmODg3YWYtYWY5YS00OGU5LTllNjEtZDA1YjUwMWVkMTRk'
                    }
                };
                try {
                    let url
                    if (process.env.NODE_ENV !== 'development') {
                        url = 'tio/refund/wx/api/attach/fileUpload';
                    } else {
                        url = 'refundApi/attach/fileUpload';
                    }
                    this.axios
                        // .post("tio/refund/wx/api/attach/fileUpload", data, config)
                        .post(url, data, config)
                        //   this.axios({
                        //   url: 'api/attach/fileUpload',
                        //   method:'post',
                        //   data,
                        //   params:{ fileBizType: 40 } // query参数
                        // })
                        .then(res => {
                            if (res.data.ret === 0 && res.data.data) {
                                console.log('res.data.data[0].attachId', res.data.data[0].attachId);
                                this.uploadFile.push(res.data.data[0].attachId);
                                this.uploadFileUrl.push(res.data.data[0].fileUrl)
                                let key = currentFile.file.lastModified;

                                // let obj = {};
                                // obj[key] = res.data.data[0].attachId;
                                // this.temporaryFiles.push(obj);

                                this.temporaryFiles.push(files);

                                // this.$dispatch("fileUploadData", this.uploadFile);
                                this.$emit('fileuploadData', this.uploadFile, this.uploadFileUrl);
                                if (this.$route.fullPath == '/refund/secondRefund') {
                                    localStorage.setItem('fileCache', JSON.stringify(this.files))
                                }
                                // this.$store.commit('refund/addTempFiles', res.data.data[0])
                            } else {
                                this.$toast({
                                    message: res.data.msg,
                                    duration: 2000
                                });
                            }
                            this.$Toast.clear();
                        });
                } catch (error) {
                    console.log(error);
                    this.$Toast.clear();
                }
            }
        },
        destroyed () {
            this.$Toast.clear();
        }
    };
</script>

<style lang="less" scoped>
.uploadAttachment {
  width: 100%;
  .title {
    font-size: 14px;
    color: #666666;
    font-weight: 400;
    .content {
      font-size: 12px;
      color: #aaa;
    }
    // height: 60px;
    margin-bottom: 12px;
  }
  /deep/.uploadBox {
    margin-bottom: -20px;
    position: relative;
    .van-uploader__preview-image {
        width: 75px !important;
        height: 75px !important;
    }

    .van-uploader__input-wrapper {
        border: none !important;
        border-radius: 4px;
        .van-uploader__input {
            width: 80px;
            height: 80px;
        }
    }
    .uploadIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        img {
            width: 26px;
            height: 26px;
        }
    }
    .my-delicon {
      width: 18px;
      height: 18px;
      position:absolute;
      right: 0;
      top: 0;
    }
    .van-uploader__upload {
      background-color: white;
      border: 1px dashed #cdcdce;
    }
    .van-uploader__preview-delete::before {
      opacity: 0;
      background-size: 100% 100%;
      background-image: url("../../../../assets/refund/ic_delete.png");
    }
    .van-uploader__preview::after {
      content: '';
      pointer-events: none;
      position: absolute;
      right: 0;
      top: -6px;
      width: 18px;
      height: 18px;
      background-image: url('../../../../assets/refund/ic_delete.png');
      background-size: 100% 100%;
    }
  }
}
</style>
<style lang="less" scoped>
.uploadAttachment {
  .uploadBox {
    .van-uploader {
      .van-uploader__wrapper {
        .van-uploader__upload {
          border: 1px solid red !important;
        }
      }
    }
  }
}
</style>
